export default __webpack_public_path__ + "static/media/signin_white.192fabd4.svg";